export const mutationTypes = {
    addMessageToQueue: "[flash messages] Add message to queue",
    removeMessageFromQueue: "[flash messages] Remove message from queue",
    removeAllMessages: "[flash messages] Remove all messages",
};

export const getterTypes = {
    getMessages: "[flash messages] Get messages",
};
